/* ============
 * Footer Component
 * ============
 *
 * todo: add documentation here!
 */

export default {
};



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.js